import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_accounting_period_selector = _resolveComponent("oss-accounting-period-selector")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DoughnutChart = _resolveComponent("DoughnutChart")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "default_card large",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "px-1 py-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_accounting_period_selector, {
                modelValue: _ctx.accountingPeriod,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                global: false,
                "company-id": _ctx.companyId,
                "hide-details": "",
                density: "compact"
              }, null, 8, ["modelValue", "company-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "px-1 py-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_text_field, {
                modelValue: _ctx.accountingPeriod.amountSubsciption,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountingPeriod.amountSubsciption) = $event)),
                density: "compact",
                "hide-details": "",
                label: "Montant du forfait"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "d-flex justify-end align-center px-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                rounded: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update())),
                size: "small"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Valider ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.accountingPeriod.amountSubsciption)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DoughnutChart, {
                    data: _ctx.dataset,
                    options: _ctx.chartOptions,
                    height: _ctx.$vuetify.display.mobile ? 200 : 350
                  }, null, 8, ["data", "options", "height"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12",
                class: "d-flex justify-center pa-8 subtitle-1"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Entrez un montant pour le forfait ")
                ])),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}